import * as Yup from 'yup';
import { ALIGN_TYPES } from "../../../configs/TableHeaderConstants";
import VALUE_TYPES from '../../../configs/ValueTypeConstants';

const months = [
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" }
]

export const InitialInvoiceState = {
    school_id: null,
    fee_type: "Fees",
    student_id: null,
    student_name: null,
    class_id: null,
    division: null,
    zone_id: null,
    transport_type_id: null,
    // academic_year: null,
    parent_name: null,
    other_ref: null,
    debit_ledger_id: null,
    credit_ledger_id: null,
    period: null,
    term_id: null,
    invoice_date: null,
    post_date: null,
    remarks: null,
    invoice_start_date: null,
    invoice_end_date: null,
    invoice_no: null,
    academic_year_id: null,
    invoice_status: true,
};

export const InvoiceSchema = Yup.object().shape({
    school_id: Yup.number().required(),
    fee_type: Yup.string().required(),
    student_id: Yup.number().required(),
    student_name: Yup.string().nullable(),
    class_id: Yup.number().nullable(),
    division: Yup.string().nullable(),
    zone_id: Yup.number().nullable(),
    transport_type_id: Yup.number().nullable(),
    // academic_year: Yup.string().nullable(),
    parent_name: Yup.string().nullable(),
    other_ref: Yup.string().nullable(),
    debit_ledger_id: Yup.number().nullable(),
    credit_ledger_id: Yup.number().required(),
    // area_id: Yup.number().nullable(),
    period: Yup.string().required(),
    term_id: Yup.number().nullable(),
    invoice_date: Yup.date().required(),
    post_date: Yup.date().required(),
    remarks: Yup.string().nullable(),
    invoice_start_date: Yup.date().nullable(),
    invoice_end_date: Yup.date().nullable(),
    invoice_no: Yup.string().nullable(),
    academic_year_id: Yup.number().nullable(),
    invoice_status: Yup.boolean().required()

});

export const InvoiceFormFields = [
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "fee_type", title: "Fee Type", required: true, type: VALUE_TYPES.SELECT, options: [{ name: "Fees", id: "Fees" }, { name: "Contract", id: "Contract" }], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "student_id", title: "Student Code", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "student_name", title: "Student Name", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    // { name: "class", title: "Class", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "class_id", title: "Class", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id", disabled: true },
    { name: "division", title: "Division", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    // { name: "zone", title: "Zone", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "zone_id", title: "Zone", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id", disabled: true },
    // { name: "transport_type", title: "Transport Type", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "transport_type_id", title: "Transport Type", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "type", itemValue: "id", disabled: true },
    // { name: "academic_year", title: "Academic Year", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "academic_year_id", title: "Academic Year", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "academic_year", itemValue: "id", disabled: true },
    { name: "parent_name", title: "Parent Name", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "other_ref", title: "Other Ref", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "debit_ledger_id", title: "Debit Ledger", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id", disabled: true },
    { name: "credit_ledger_id", title: "Credit Ledger", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "invoice_start_date", title: "Invoice Start Date", required: false, type: VALUE_TYPES.DATEPICKER, disabled: true },
    { name: "invoice_end_date", title: "Inv End Date", required: false, type: VALUE_TYPES.DATEPICKER, disabled: true },
    // { name: "area_id", title: "Area", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "period", title: "Period", required: true, type: VALUE_TYPES.SELECT, options: months, displayKey: "month", itemValue: "month" },
    { name: "term_id", title: "Term", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "invoice_no", title: "Invoice Number", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "invoice_date", title: "Invoice Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "post_date", title: "Post Date", required: true, type: VALUE_TYPES.DATEPICKER, disabled: true },
    { name: "remarks", title: "Remarks", required: false, type: VALUE_TYPES.TEXT },
    { name: "invoice_status", title: "Status", required: true, type: VALUE_TYPES.SWITCH, options: [{ title: "Active", id: true }, { title: "In-Active", id: false }] },
];

export const InitialInvoiceContractState = {
    school_id: null,
    fee_type: "Contract",
    invoice_date: null,
    invoice_issued: null,
    trn_no: null,
    address: null,
    invoice_no: null,
    kind_attn: null,
    invoice_status: true,
};

export const InvoiceContractSchema = Yup.object().shape({
    school_id: Yup.number().required(),
    fee_type: Yup.string().required(),
    invoice_date: Yup.date().required(),
    invoice_issued: Yup.string().required(),
    trn_no: Yup.string().required(),
    address: Yup.string().required(),
    invoice_no: Yup.string().nullable(),
    kind_attn: Yup.string().nullable(),
    invoice_status: Yup.boolean().required()
});

export const InvoiceContractFormFields = [
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "fee_type", title: "Fee Type", required: true, type: VALUE_TYPES.SELECT, options: [{ name: "Fees", id: "Fees" }, { name: "Contract", id: "Contract" }], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "invoice_no", title: "Invoice Number", required: false, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "invoice_date", title: "Invoice Date", required: true, type: VALUE_TYPES.DATEPICKER },
    { name: "invoice_issued", title: "Invoice Issued To", required: true, type: VALUE_TYPES.TEXT },
    { name: "trn_no", title: "TRN NO", required: true, type: VALUE_TYPES.TEXT },
    { name: "address", title: "Address", required: true, type: VALUE_TYPES.TEXT },
    { name: "kind_attn", title: "Kind Attn", required: false, type: VALUE_TYPES.TEXT },
    { name: "invoice_status", title: "Status", required: true, type: VALUE_TYPES.SWITCH, options: [{ title: "Active", id: true }, { title: "In-Active", id: false }] },
];


export const invoiceTypes = {
    "Fees": {
        "state": InitialInvoiceState,
        "schema": InvoiceSchema,
        "formFields": InvoiceFormFields,
    },
    "Contract": {
        "state": InitialInvoiceContractState,
        "schema": InvoiceContractSchema,
        "formFields": InvoiceContractFormFields,
    }
};

export const InitialInvoiceLineState = {
    description: null,
    area_id: null,
    amount: null,
    vat_percentage: "Exampt",
    vat_ammount: 0
};

export const InvoiceLineSchema = Yup.object().shape({
    area_id: Yup.number().required(),
    amount: Yup.number().required(),
    vat_percentage: Yup.string().required(),
    vat_amount: Yup.number().nullable(),
    description: Yup.string().nullable(),
});

export const InvoiceLineFormFields = [
    { name: "area_id", title: "Area", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "description", title: "Description", required: false, type: VALUE_TYPES.TEXTAREA },
    { name: "amount", title: "Amount (AED)", required: true, type: VALUE_TYPES.DECIAML },
    { name: "vat_percentage", title: "Vat", required: true, type: VALUE_TYPES.TEXT, disabled: true },
    { name: "vat_amount", title: "Vat Amount", required: true, type: VALUE_TYPES.NUMBER, disabled: true },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },
];

export const InitialInvoiceLineOtherInvoicesState = {
    description: null,
    amount: null,
    vat_percentage: 5,
    vat_amount: 0,
    total_amount: 0
};

export const InvoiceLineOtherInvoicesSchema = Yup.object().shape({
    description: Yup.string().nullable(),
    amount: Yup.number().required(),
    vat_percentage: Yup.number().nullable().min(0).max(100),
    vat_amount: Yup.number().nullable(),
    total_amount: Yup.number().nullable()
});

export const InvoiceLineOtherInvoicesFormFields = [
    { name: "amount", title: "Amount (AED)", required: true, type: VALUE_TYPES.DECIAML },
    { name: "description", title: "Description", required: false, type: VALUE_TYPES.TEXTAREA },
    { name: "vat_percentage", title: "VAT %", required: true, type: VALUE_TYPES.DECIAML },
    { name: "vat_amount", title: "VAT Amount", required: true, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "total_amount", title: "Total Amount (AED)", required: true, type: VALUE_TYPES.DECIAML, disabled: true },
];

export const InitialInvoiceLineContractState = {
    description: null,
    debit_ledger_id: null,
    amount: null,
    vat_percentage: "Exempt",
    vat_amount: 0,
    total_amount: 0,
    credit_ledger_id: null,
    credit_amount: null
};

export const InvoiceLineContractSchema = Yup.object().shape({
    description: Yup.string().required(),
    debit_ledger_id: Yup.number().required(),
    amount: Yup.number().required(),
    vat_percentage: Yup.string().required(),
    vat_amount: Yup.number().required(),
    total_amount: Yup.number().required(),
    credit_ledger_id: Yup.number().required(),
    credit_amount: Yup.number().required()
});

export const InvoiceLineContractFormFields = [
    { name: "description", title: "Description", required: false, type: VALUE_TYPES.TEXTAREA },
    { name: "debit_ledger_id", title: "Debit Ledger", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "amount", title: "Amount (AED)", required: true, type: VALUE_TYPES.DECIAML },
    { name: "vat_percentage", title: "VAT %", required: true, type: VALUE_TYPES.SELECT, options: [{ name: "Exempt" }, { name: "5%" }], apiRequired: true, displayKey: "name", itemValue: "name" },
    { name: "vat_amount", title: "VAT Amount", required: true, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "total_amount", title: "Total Amount (AED)", required: true, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "credit_ledger_id", title: "Credit Ledger", required: true, type: VALUE_TYPES.AUTOCOMPLETE, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "credit_amount", title: "Credit Amount", required: true, type: VALUE_TYPES.DECIAML, disabled: true },
    { name: "actions", title: "Actions", required: true, type: VALUE_TYPES.ACTIONS, disabled: false },
];

const INVOICE_LINES_TABLE_HEADS = [
    { id: 'area', label: 'Area', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT, width: 250 },
    { id: 'description', label: 'Description', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT, width: 500 },
    { id: 'amount', label: 'Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER, width: 150 },
    { id: 'vat_percentage', label: 'VAT Percentage', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.NUMBER, width: 150 },
    { id: 'vat_amount', label: 'VAT Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER, width: 150 },
    { id: 'total_amount', label: 'Total Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER, width: 150 },
]

const INVOICE_LINES_CONTRACT_TABLE_HEADS = [
    { id: 'description', label: 'Particulars/Detail/Narration', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT, width: 500 },
    { id: 'debit_ledger_name', label: 'Debit Ledger', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT, width: 400 },
    { id: 'amount', label: 'Amount (AED)', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER, width: 150 },
    { id: 'vat_percentage', label: 'VAT', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.NUMBER, width: 150 },
    { id: 'vat_amount', label: 'Vat Amt', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER, width: 150 },
    { id: 'total_amount', label: 'Total AED', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER, width: 150 },
    { id: 'credit_ledger_name', label: 'Credit Ledger', align: ALIGN_TYPES.ALIGN_LEFT, type: VALUE_TYPES.TEXT, width: 400 },
    { id: 'credit_amount', label: 'Credit Amount', align: ALIGN_TYPES.ALIGN_RIGHT, type: VALUE_TYPES.NUMBER, width: 150 },
]

export const invoiceLineTypes = {
    "Fees": {
        "state": InitialInvoiceLineState,
        "schema": InvoiceLineSchema,
        "formFields": InvoiceLineFormFields,
        "tableHeaders": INVOICE_LINES_TABLE_HEADS
    },
    "Contract": {
        "state": InitialInvoiceLineContractState,
        "schema": InvoiceLineContractSchema,
        "formFields": InvoiceLineContractFormFields,
        "tableHeaders": INVOICE_LINES_CONTRACT_TABLE_HEADS
    },
    "Other Invoices": {
        "state": InitialInvoiceLineOtherInvoicesState,
        "schema": InvoiceLineOtherInvoicesSchema,
        "formFields": InvoiceLineOtherInvoicesFormFields
    },
};

const filterState = {
    fee_types: null,
    schools: null,
    students: null,
    periods: null,
    invoice_from_date: null,
    invoice_to_date: null,
    status: null,
};
const filterSchema = Yup.object().shape({
    fee_types: Yup.array().nullable(),
    schools: Yup.array().nullable(),
    students: Yup.array().nullable(),
    periods: Yup.array().nullable(),
    invoice_from_date: Yup.date().nullable(),
    invoice_to_date: Yup.date().nullable(),
    status: Yup.string().nullable(),
});

const filterFormFields: any[] = [
    { name: "fee_types", title: "Fee Types", required: false, type: VALUE_TYPES.MULTISELECT, options: [{ name: "Fees" }, { name: "Contract" }], apiRequired: true, displayKey: "name", itemValue: "name" },
    { name: "schools", title: "Schools", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "students", title: "Students", required: false, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "code_name", itemValue: "id" },
    { name: "periods", title: "Periods", required: false, type: VALUE_TYPES.MULTISELECT, options: months, apiRequired: true, displayKey: "month", itemValue: "month" },
    { name: "invoice_from_date", title: "Invoice From Date", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "invoice_to_date", title: "Invoice To Date", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "status", title: "Status", required: false, type: VALUE_TYPES.SELECT, options: [{ name: "Active" }, { name: "In-Active" }], apiRequired: true, displayKey: "name", itemValue: "name" },
];

export const filter = {
    state: filterState,
    schema: filterSchema,
    formFields: filterFormFields
}

